/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from '../../index.css';

export interface ILabel {
  invalid: boolean;
  freeDealRent: boolean;
}

export const Label = ({ invalid, freeDealRent }: ILabel) => (
  <span {...mergeStyles(styles['term-description'], invalid && styles['label-invalid'])}>
    {freeDealRent ? (
      <>
        {' '}
        Отправляя анкету, я даю согласие на обработку моих персональных данных в соответствии с{' '}
        <a className={styles['link']} href="https://www.cian.ru/help/about/36526/" target="_blank">
          политикой конфиденциальности
        </a>{' '}
        и условиями{' '}
        <a
          className={styles['link']}
          href="http://files.cian.ru/files/arenda-bez-riska/oferta-idealnyj-arendator.pdf"
          target="_blank"
        >
          оферты
        </a>
      </>
    ) : (
      <>
        Отправляя анкету, я даю согласие на обработку моих персональных данных в соответствии с{' '}
        <a className={styles['link']} href="https://www.cian.ru/help/about/36526/" target="_blank">
          политикой конфиденциальности
        </a>
      </>
    )}
  </span>
);
